// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"259b031e","455":"0ce72bee"}[chunkId] + ".chunk.js";
};